export { about } from "./about";
export { agreement } from "./agreement";
export { anshinpack } from "./anshinpack";
export { asct } from "./asct";
export { corporate } from "./corporate";
export { policy } from "./policy";
export { privacy } from "./privacy";
export { search_campaign } from "./search_campaign";
export { service } from "./service";
export { sitemap } from "./sitemap";
export { smartkey } from "./smartkey/change";
export { search_campaign_tdf } from "./search_campaign_tdf";
export { notfound } from './notfound';
export { trunkwithrack } from "./trunkwithrack";
export { newtrunkroom } from "./newtrunkroom";
export { concierge } from "./concierge";



// WEBPACK FOOTER //
// ./pages/static/index.js